import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionPlanService, CreateSubscriptionPlanPayload } from '@services/subscription-plan';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useCreateSubscriptionPlan = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['subscriptionPlans', 'create'],
    mutationFn: async (payload: CreateSubscriptionPlanPayload) => {
      return await subscriptionPlanService.create(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscriptionPlans'] });
      toast.success(tActionMessages.subscriptionPlanCreatedSuccessfully);
    },
    onError: (error: any) => {
      console.error('Create subscription plan error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.message ||
        'Failed to create subscription plan';
      toast.error(errorMessage);
    },
  });
};
